import React from 'react';
import { Box } from '@withjoy/joykit';

// Mirrors the messaging center's `SmsPhonePreview`, in a lighter gray so it doesn't outweigh the PDP's CTA.
const PHONE_BEZEL_COLOR = 'mono13';
const PHONE_MAX_WIDTH = 300;
const PHONE_RADIUS = '44px';

type CardPhoneFrameProps = Readonly<{
  /** The screen. Fills the whole frame; the dynamic island floats over it. */
  children: React.ReactNode;
}>;

export const CardPhoneFrame = ({ children }: CardPhoneFrameProps) => {
  return (
    <Box
      width="100%"
      maxWidth={PHONE_MAX_WIDTH}
      aspectRatio="390 / 760"
      border="6px solid"
      borderColor={PHONE_BEZEL_COLOR}
      borderRadius={PHONE_RADIUS}
      backgroundColor="white"
      overflow="hidden"
      position="relative"
    >
      <Box height="100%">{children}</Box>
      {/* Dynamic island. Floats over the screen so content centres on the whole frame. */}
      <Box
        position="absolute"
        top="16px"
        left="50%"
        transform="translateX(-50%)"
        width="86px"
        height="24px"
        borderRadius="999px"
        backgroundColor={PHONE_BEZEL_COLOR}
      />
    </Box>
  );
};
